import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const MobileRefreshControl = ({ onRefresh }) => {
  const [isRefreshing, setIsRefreshing] = useState(false);
  const [pullDistance, setPullDistance] = useState(0);
  const [startY, setStartY] = useState(0);

  const threshold = 80;

  const handleTouchStart = (e) => {
    if (window.scrollY === 0) {
      setStartY(e?.touches?.[0]?.clientY);
    }
  };

  const handleTouchMove = (e) => {
    if (window.scrollY === 0 && startY > 0) {
      const currentY = e?.touches?.[0]?.clientY;
      const distance = Math.max(0, Math.min(currentY - startY, threshold * 1.5));
      setPullDistance(distance);
    }
  };

  const handleTouchEnd = async () => {
    if (pullDistance >= threshold && !isRefreshing) {
      setIsRefreshing(true);
      await onRefresh();
      setTimeout(() => {
        setIsRefreshing(false);
        setPullDistance(0);
        setStartY(0);
      }, 1000);
    } else {
      setPullDistance(0);
      setStartY(0);
    }
  };

  const rotation = (pullDistance / threshold) * 360;
  const opacity = Math.min(pullDistance / threshold, 1);

  return (
    <>
      <div
        className="fixed top-0 left-0 right-0 z-40 flex items-center justify-center pointer-events-none"
        style={{
          height: `${pullDistance}px`,
          opacity: opacity,
          transition: isRefreshing ? 'all 0.3s ease' : 'none'
        }}
      >
        <div
          className="bg-primary rounded-full p-3 shadow-lg"
          style={{
            transform: `rotate(${rotation}deg)`,
            transition: isRefreshing ? 'transform 0.3s ease' : 'none'
          }}
        >
          <Icon
            name={isRefreshing ? 'Loader2' : 'RefreshCw'}
            size={24}
            color="var(--color-primary-foreground)"
            className={isRefreshing ? 'animate-spin' : ''}
          />
        </div>
      </div>

      <div
        className="fixed inset-0 z-30 pointer-events-auto"
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}
        style={{ touchAction: pullDistance > 0 ? 'none' : 'auto' }}
      />
    </>
  );
};

export default MobileRefreshControl;